// src/components/ActivityRouter/index.js
import React, { useEffect, useRef } from "react";
import AdmissionApi from "../../Services/AdmissionApi";

const BASE = "https://api.notifyi.in/v1/student-activity";
const admissionApi = new AdmissionApi();

// simple throttle to avoid spamming logout attempts
const oncePerInterval = (fn, ms = 400) => {
  let last = 0;
  return (...args) => {
    const now = Date.now();
    if (now - last > ms) {
      last = now;
      fn(...args);
    }
  };
};

export default function ActivityRouter() {
  const userIdRef = useRef(null);
  let userId = null;
  let clientId = null;
  let appId = null;

  const callLoginApi = (userId) => {
    const isAdminLogin = localStorage.getItem("isAdminLogin");
    if(isAdminLogin) return;
    if (!userId) return;
    const payload = { userId: Number(userId) };
    clientId = localStorage.getItem("clientId") || (admissionApi.state && admissionApi.state.clientId) || "";
    appId = localStorage.getItem("appId") || (admissionApi.state && admissionApi.state.appId) || "";
    userId = typeof window !== "undefined" ? window.localStorage.getItem("userId") : null;
    try {
      admissionApi.createNew(() => {}, payload, "v1/student-activity/login");
    } catch (e) {
      // non-fatal
      // console.error("[Session] login error", e);
    }
  };

  // sendBeacon logout (no custom headers)
  const sendLogoutBeacon = () => {
    const isAdminLogin = localStorage.getItem("isAdminLogin");
    if(isAdminLogin) return;
    // if(!userId || !clientId || !appId) return;
    const userId = typeof window !== "undefined" ? window.localStorage.getItem("userId") : null;
    // if (!userId || typeof navigator === "undefined" || typeof navigator.sendBeacon !== "function") return false;
    // try {
      const clientId = localStorage.getItem("clientId") || (admissionApi.state && admissionApi.state.clientId) || "";
      const appId = localStorage.getItem("appId") || (admissionApi.state && admissionApi.state.appId) || "";
      // include userId in query params so server doesn't require JSON in body or cookies
      const qUrl = `${BASE}/logout?clientId=${encodeURIComponent(clientId)}&appId=${encodeURIComponent(appId)}&userId=${encodeURIComponent(String(userId))}`;

      return navigator.sendBeacon(qUrl);
    // } catch (err) {
    //   console.log("err=>",err)
    //   return false;
    // }
  };

  // fallback fetch with keepalive
  const sendLogoutFetch = (userId) => {
    if (!userId || typeof fetch === "undefined") return;
    try {
      const payload = JSON.stringify({ userId: Number(userId) });
      const clientId = localStorage.getItem("clientId") || (admissionApi.state && admissionApi.state.clientId) || "";
      const appId = localStorage.getItem("appId") || (admissionApi.state && admissionApi.state.appId) || "";
      fetch(`${BASE}/logout`, {
        method: "POST",
        body: payload,
        keepalive: true,
        headers: {
          "Content-Type": "application/json",
          appId,
          clientId,
        },
      }).catch(() => {});
    } catch (e) {}
  };

  const performUnloadAttemptRaw = (userId) => {
    if (!userId) return;
    try {
      localStorage.setItem("pendingLogout", JSON.stringify({ userId: String(userId), ts: Date.now() }));
    } catch (e) {}
    const ok = sendLogoutBeacon(userId);
    if (!ok) sendLogoutFetch(userId);
  };

  const performUnloadAttempt = useRef(oncePerInterval(performUnloadAttemptRaw, 300)).current;

  useEffect(() => {
    const userId = typeof window !== "undefined" ? window.localStorage.getItem("userId") : null;
    const isLogin = typeof window !== "undefined" ? window.localStorage.getItem("isLogin") : null;
    if(!isLogin || isLogin==='0') return;
    if (!userId) return;
    userIdRef.current = String(userId);
    try {
      const pendingRaw = localStorage.getItem("pendingLogout");
      if (pendingRaw) {
        const pending = JSON.parse(pendingRaw);
        if (pending && String(pending.userId) === String(userIdRef.current)) {
          localStorage.removeItem("pendingLogout");
          callLoginApi(userIdRef.current);
        } else {
          callLoginApi(userIdRef.current);
        }
      } else {
        callLoginApi(userIdRef.current);
      }
    } catch (e) {
      callLoginApi(userIdRef.current);
    }

    const handleBeforeUnload = () => sendLogoutBeacon()
    const handlePageHide = () => performUnloadAttempt(userIdRef.current);
    const handleUnload = () => performUnloadAttempt(userIdRef.current);
    const handleVisibility = () => {
      if (document.visibilityState === "hidden") performUnloadAttempt(userIdRef.current);
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("pagehide", handleBeforeUnload);
    window.addEventListener("unload", handleUnload);
    document.addEventListener("visibilitychange", handleBeforeUnload);

    return () => {
      if (userIdRef.current) performUnloadAttempt(userIdRef.current);

      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("pagehide", handleBeforeUnload);
      window.removeEventListener("unload", handleUnload);
      document.removeEventListener("visibilitychange", handleBeforeUnload);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}



/** WEBPACK FOOTER **
 ** ./src/components/ActivityRouter/index.js
 **/